export default __webpack_public_path__ + "static/media/bP.0b4c4e30.svg";